"use client";
import React from "react";

function Title({ title, description, className = "" }) {
    return (
        <section className={`w-full  py-12 ${className}`}>
            <h2
                className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 text-gray-900"
                style={{ fontFamily: "saans-bold" }}
            >
                {title}
            </h2>
            <p
                className="mb-8 text-gray-700 text-base sm:text-lg lg:text-[16px] max-w-5xl"
                style={{ fontFamily: "saans-regular" }}
            >
                {description}
            </p>
        </section>
    );
}

export default Title;
